(function(){
  'use strict';
  function track(name, detail){
    try{
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event:name},detail||{}));
      document.dispatchEvent(new CustomEvent(name,{detail:detail||{}}));
    }catch(e){}
  }
  function ready(fn){ if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn);}else{fn();} }

  ready(function(){
    if(!window.matchMedia||!window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    document.querySelectorAll('video[autoplay]').forEach(function(v){
      v.pause();
      v.removeAttribute('autoplay');
      v.loop=false;
      v.currentTime=0;
    });
  });

  ready(function(){
    var root=document.querySelector('[data-fam-guide]');
    if(!root) return;
    var drawer=root.querySelector('.fam-guide__drawer');
    var backdrop=root.querySelector('.fam-guide__backdrop');
    var launcher=root.querySelector('[data-fam-guide-open]');
    var lastFocus=null;
    var state={pet:'',goal:'',omega:''};

    function openGuide(){
      lastFocus=document.activeElement;
      drawer.hidden=false;backdrop.hidden=false;document.body.classList.add('fam-guide-open');
      launcher.setAttribute('aria-expanded','true');
      setTimeout(function(){var close=root.querySelector('.fam-guide__close');if(close)close.focus();},0);
      track('fam_routine_guide_open',{page:location.pathname});
    }
    function closeGuide(){
      drawer.hidden=true;backdrop.hidden=true;document.body.classList.remove('fam-guide-open');
      launcher.setAttribute('aria-expanded','false');
      if(lastFocus&&lastFocus.focus)lastFocus.focus();
    }
    root.querySelectorAll('[data-fam-guide-open]').forEach(function(el){el.addEventListener('click',openGuide);});
    document.querySelectorAll('[data-fam-open-guide]').forEach(function(el){el.addEventListener('click',function(e){e.preventDefault();openGuide();});});
    root.querySelectorAll('[data-fam-guide-close]').forEach(function(el){el.addEventListener('click',closeGuide);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!drawer.hidden)closeGuide();});

    function focusableInDrawer(){
      return Array.prototype.slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(el){return el.offsetParent!==null;});
    }
    document.addEventListener('keydown',function(e){
      if(e.key!=='Tab'||drawer.hidden)return;
      var focusable=focusableInDrawer();
      if(!focusable.length)return;
      var first=focusable[0],last=focusable[focusable.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
      else if(!drawer.contains(document.activeElement)){e.preventDefault();first.focus();}
    });

    function setStep(n){
      root.querySelectorAll('[data-fam-guide-step]').forEach(function(el){var active=Number(el.getAttribute('data-fam-guide-step'))===n;el.hidden=!active;el.classList.toggle('is-active',active);});
      root.querySelectorAll('[data-fam-guide-progress]').forEach(function(el){el.classList.toggle('is-active',Number(el.getAttribute('data-fam-guide-progress'))<=n);});
      drawer.scrollTop=0;
    }
    function clearSelections(selector){root.querySelectorAll(selector).forEach(function(el){el.classList.remove('is-selected');});}
    function updateGoalRules(){
      var cat=state.pet==='cat';
      root.querySelectorAll('[data-fam-goal="digestion"],[data-fam-goal="joints"]').forEach(function(btn){btn.hidden=cat;btn.disabled=cat;});
      root.querySelector('[data-fam-cat-note]').hidden=!cat;
      if(cat){state.goal='skin';root.querySelectorAll('[data-fam-goal]').forEach(function(btn){btn.classList.toggle('is-selected',btn.getAttribute('data-fam-goal')==='skin');});}
      root.querySelector('[data-fam-guide-next]').disabled=!state.goal;
    }
    root.querySelectorAll('[data-fam-pet]').forEach(function(btn){btn.addEventListener('click',function(){
      state={pet:this.getAttribute('data-fam-pet'),goal:'',omega:''};
      root.querySelectorAll('[data-fam-pet]').forEach(function(b){b.classList.toggle('is-selected',b===btn);});
      clearSelections('[data-fam-goal],[data-fam-omega]');
      updateGoalRules();
      if(state.pet==='cat'){
        renderOmegaQuestion();setStep(3);
      }else{
        setStep(2);
      }
      track('fam_routine_pet_selected',{pet:state.pet});
    });});
    root.querySelectorAll('[data-fam-goal]').forEach(function(btn){btn.addEventListener('click',function(){
      state.goal=this.getAttribute('data-fam-goal');state.omega='';
      root.querySelectorAll('[data-fam-goal]').forEach(function(b){b.classList.toggle('is-selected',b===btn);});
      root.querySelector('[data-fam-guide-next]').disabled=false;
    });});

    function renderOmegaQuestion(){
      var options=[],title=root.querySelector('[data-fam-omega-title]'),copy=root.querySelector('[data-fam-omega-copy]');
      if(state.pet==='cat'||state.goal==='skin'||state.goal==='unsure'){
        title.textContent='How will you use Omega-3 Spray?';
        copy.textContent='Choose the purpose that best matches the daily routine.';
        options=[
          {value:'full',title:'Full daily omega-3 support',copy:'Follow the weight-based feeding direction on the label.'},
          {value:'topper',title:'Light meal topper',copy:'One quick 1-second spray (about 1/2 tsp) for flavour and picky eaters — the full amount for dogs up to 20 lb, a topper amount for bigger dogs.'}
        ];
      }else{
        title.textContent='Would you also like Omega-3 Spray?';
        copy.textContent='Keep the recommendation focused, or add fish oil only for a clear purpose.';
        options=[
          {value:'none',title:'No—keep it focused',copy:'Recommend only the core chew for the main priority.'},
          {value:'full',title:'Add full daily omega-3 support',copy:'Follow the weight-based feeding direction on the label.'},
          {value:'topper',title:'Add as a light meal topper',copy:'One quick 1-second spray (about 1/2 tsp) for flavour — the full amount for dogs up to 20 lb, a topper amount for bigger dogs.'}
        ];
      }
      var wrap=root.querySelector('[data-fam-omega-options]');
      wrap.innerHTML=options.map(function(o){return '<button type="button" data-fam-omega="'+o.value+'"><strong>'+o.title+'</strong><span>'+o.copy+'</span></button>';}).join('');
      wrap.querySelectorAll('[data-fam-omega]').forEach(function(btn){btn.addEventListener('click',function(){state.omega=this.getAttribute('data-fam-omega');wrap.querySelectorAll('[data-fam-omega]').forEach(function(b){b.classList.toggle('is-selected',b===btn);});renderResult();});});
    }
    root.querySelector('[data-fam-guide-next]').addEventListener('click',function(){if(!state.goal)return;renderOmegaQuestion();setStep(3);});
    root.querySelectorAll('[data-fam-guide-back]').forEach(function(btn){btn.addEventListener('click',function(){
      var active=root.querySelector('.fam-guide__step.is-active');var n=Number(active&&active.getAttribute('data-fam-guide-step'))||1;
      if(n===3){root.querySelector('[data-fam-guide-result]').hidden=true;root.querySelector('[data-fam-guide-question]').hidden=false;root.querySelector('[data-fam-guide-restart]').hidden=true;state.omega='';setStep(2);}else if(n===2){setStep(1);}
    });});
    root.querySelector('[data-fam-guide-restart]').addEventListener('click',function(){
      state={pet:'',goal:'',omega:''};clearSelections('.is-selected');root.querySelector('[data-fam-guide-result]').hidden=true;root.querySelector('[data-fam-guide-question]').hidden=false;this.hidden=true;setStep(1);
    });

    function renderResult(){
      if(!state.omega)return;
      var title='',copy='',url='',reasons=[],subscription='';
      var topper=state.omega==='topper',full=state.omega==='full';
      if(state.pet==='cat'||state.goal==='skin'||state.goal==='unsure'){
        title='Omega-3 Fish Oil Spray';
        copy=topper?'Use one quick one-second spray (about 1/2 tsp) over food for fish-oil flavour and meal appeal. For dogs up to 20 lb this happens to be the full daily amount; for bigger dogs it is a smaller topper amount, not the full serving described on the label.':'Use the weight-based feeding direction for the full daily omega-3 serving.';
        url='/products/omega-3-fish-oil-spray-for-dogs-cats#purchase-options';
        reasons=['Made for dogs and cats','Airless inner bag helps limit repeated air contact',topper?'Flexible topper use':'Weight-based full-support serving'];
        subscription=topper?'Used only as a topper, one bottle can last up to 60 days — choose a longer delivery interval and adjust after seeing actual use.':'Compare one-time and Subscribe & Save delivery options on the product page.';
      }else if(state.goal==='digestion'&&state.omega==='none'){
        title='Probiotic+ Soft Chews';
        copy='A focused starting point for daily gut balance, digestion, and stool support without automatically adding another product.';
        url='/products/probiotic-soft-chews-dogs#purchase-options';
        reasons=['2 billion CFU of Bacillus subtilis per chew','Pumpkin seed, ginger root, and marshmallow root','Each chew sealed separately until serving'];
        subscription='The product page shows one-time and eligible Subscribe & Save options side by side.';
      }else if(state.goal==='joints'&&state.omega==='none'){
        title='Hip & Joint Soft Chews';
        copy='A focused starting point for daily joint and mobility support without automatically adding another product.';
        url='/products/hip-joint-soft-chews-dogs#purchase-options';
        reasons=['Five listed mobility-support ingredients','One simple 60 count pouch','Each chew sealed separately until serving'];
        subscription='The product page shows one-time and eligible Subscribe & Save options side by side.';
      }else{
        var coreName=state.goal==='digestion'?'Probiotic+':'Hip & Joint';
        var coreUrl=state.goal==='digestion'?'/products/probiotic-soft-chews-dogs':'/products/hip-joint-soft-chews-dogs';
        title=coreName+' Soft Chews';
        copy=coreName+' remains the core product for this priority. Omega-3 Spray is added '+(full?'for the full weight-based daily serving.':'only as a light meal topper, not as the full omega-3 serving.')+' Add it from its own product page — this guide keeps one clear recommendation at a time.';
        url=coreUrl+'#purchase-options';
        reasons=['One core product for the main priority','Omega-3 added only because you chose it','Price and delivery timing shown before cart'];
        subscription='Start with '+coreName+', then add Omega-3 Spray from its own product page whenever you are ready.';
      }
      root.querySelector('[data-fam-result-title]').textContent=title;
      root.querySelector('[data-fam-result-copy]').textContent=copy;
      root.querySelector('[data-fam-result-link]').setAttribute('href',url);
      root.querySelector('[data-fam-result-link]').textContent='See product and delivery options';
      root.querySelector('[data-fam-result-reason]').innerHTML=reasons.map(function(x){return '<span>'+x+'</span>';}).join('');
      root.querySelector('[data-fam-result-subscription]').textContent=subscription;
      root.querySelector('[data-fam-guide-result]').hidden=false;
      root.querySelector('[data-fam-guide-question]').hidden=true;
      root.querySelector('[data-fam-guide-restart]').hidden=false;
      track('fam_routine_recommendation',{pet:state.pet,goal:state.goal,omega_mode:state.omega,recommendation:title});
    }

    document.addEventListener('click',function(e){
      var cta=e.target.closest('a,button');if(!cta)return;
      if(cta.matches('.prod-add-btn,[name="checkout"],[data-cart],.fam-main-cta,.fam-buy-button,.fam-btn')){
        track('fam_conversion_cta_click',{label:(cta.textContent||'').trim().slice(0,80),path:location.pathname});
      }
    });
  });
})();
